import { travelTypeObject } from '../../enumeration';
import { PATH_DASHBOARD } from '../../routes/paths';
import api from '../../services/api';

const EAgent = {
  title: {
    name: ['کارشناس', 'کارشناسان'],
  },
  routes: PATH_DASHBOARD.agent,
  api: api.admin,
  // apiParams: { agent_id: [13,14,15] },
  agent_id: [13, 14, 15],
  not_agent_id: [1, 2, 3 , 4],
  apiParams: { is_agent: 0 },
  enum: {
    array: Object.values(travelTypeObject),
    object: travelTypeObject,
  },
};

export default EAgent;
